var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthenticatedApiService } from './authenticated-api.service';
import { Injectable } from '@angular/core';
import { ShuttleBuilder } from './../builders/shuttle-builder';
import { ApiService } from "./api.service";
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
import * as i2 from "./api.service";
export class ShuttleApiService {
    constructor(authenticatedApi, unauthenticatedApi) {
        this.authenticatedApi = authenticatedApi;
        this.unauthenticatedApi = unauthenticatedApi;
    }
    list(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/shuttle/list`, payload).toPromise();
            return ShuttleBuilder.buildShuttleList(response);
        });
    }
    listAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unauthenticatedApi.get(`/shuttle/list_all`).toPromise();
            return response.shuttles.map(shuttle => ShuttleBuilder.buildShuttle(shuttle));
        });
    }
    listAllAlive() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unauthenticatedApi.get(`/shuttle/list_all_alive`).toPromise();
            return response.shuttles.map(shuttle => ShuttleBuilder.buildShuttle(shuttle));
        });
    }
    get(shuttle_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/shuttle/${shuttle_id}`).toPromise();
            return ShuttleBuilder.buildShuttle(response);
        });
    }
    create(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.post('/shuttle', payload).toPromise();
            return ShuttleBuilder.buildShuttle(response);
        });
    }
    update(shuttle_id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.put(`/shuttle/${shuttle_id}`, payload).toPromise();
            return ShuttleBuilder.buildShuttle(response.shuttle);
        });
    }
    updateStatus(shuttle_id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.put(`/shuttle/status_update/${shuttle_id}`, payload).toPromise();
            return ShuttleBuilder.buildShuttle(response.shuttle);
        });
    }
    deleteShuttle(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.delete(`/shuttle/${id}`).toPromise();
            return response.status;
        });
    }
    listShuttleStatusLogsByLot(id_lot) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/shuttle/status_log/${id_lot}`).toPromise();
            return response.shuttle_logs.map(log => ShuttleBuilder.buildShuttleStatusLog(log));
        });
    }
    listShuttleStatusLogs(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/shuttle/status_log_list`, payload).toPromise();
            return ShuttleBuilder.buildShuttleStatusLogsList(response);
        });
    }
    listAllShuttleInfoPanel(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.unauthenticatedApi.get('/shuttle/list_all_shuttle_info_panel', payload).toPromise();
            return ShuttleBuilder.buildShuttleInfoPanelList(response);
        });
    }
    getShuttleInfoPanel(shuttle_info_panel_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unauthenticatedApi.get(`/shuttle/shuttle_info_panel/${shuttle_info_panel_id}`).toPromise();
            return ShuttleBuilder.buildShuttleInfoPanel(response.shuttle_info_panel);
        });
    }
    getShuttleInfoPanelByAuth(shuttle_info_panel_auth) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unauthenticatedApi.get(`/shuttle/shuttle_info_panel_byauth/${shuttle_info_panel_auth}`).toPromise();
            return ShuttleBuilder.buildShuttleInfoPanel(response.shuttle_info_panel);
        });
    }
    createShuttleInfoPanel(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.post(`/shuttle/shuttle_info_panel/`, payload).toPromise();
            return ShuttleBuilder.buildShuttleInfoPanel(response.shuttle_info_panel);
        });
    }
    updateShuttleInfoPanel(shuttle_info_panel_id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.put(`/shuttle/shuttle_info_panel/${shuttle_info_panel_id}`, payload).toPromise();
            return ShuttleBuilder.buildShuttleInfoPanel(response.shuttle_info_panel);
        });
    }
    deleteShuttleInfoPanel(shuttle_info_panel_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.delete(`/shuttle/shuttle_info_panel/${shuttle_info_panel_id}`).toPromise();
            return response.status;
        });
    }
    listShuttlePanelSlide(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.unauthenticatedApi.get('/shuttle/list_shuttle_panel_slide', payload).toPromise();
            return ShuttleBuilder.buildShuttlePanelSlideList(response);
        });
    }
    getShuttlePanelSlide(shuttle_panel_slide_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unauthenticatedApi.get(`/shuttle/shuttle_panel_slide/${shuttle_panel_slide_id}`).toPromise();
            return ShuttleBuilder.buildShuttlePanelSlide(response.shuttle_panel_slides);
        });
    }
    getShuttlePanelSlideByInfoID(shuttle_info_panel_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unauthenticatedApi.get(`/shuttle/shuttle_panel_slide_infoid/${shuttle_info_panel_id}`).toPromise();
            return ShuttleBuilder.buildShuttlePanelSlide(response.shuttle_panel_slides);
        });
    }
    createShuttlePanelSlide(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.post(`/shuttle/shuttle_panel_slide/`, payload).toPromise();
            return ShuttleBuilder.buildShuttlePanelSlide(response.shuttle_panel_slide);
        });
    }
    updateShuttlePanelSlide(shuttle_panel_slide_id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.put(`/shuttle/shuttle_panel_slide/${shuttle_panel_slide_id}`, payload).toPromise();
            return ShuttleBuilder.buildShuttlePanelSlide(response.shuttle_panel_slide);
        });
    }
    deleteShuttlePanelSlide(shuttle_panel_slide_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.delete(`/shuttle/shuttle_panel_slide/${shuttle_panel_slide_id}`).toPromise();
            return response.status;
        });
    }
}
ShuttleApiService.ɵfac = function ShuttleApiService_Factory(t) { return new (t || ShuttleApiService)(i0.ɵɵinject(i1.AuthenticatedApiService), i0.ɵɵinject(i2.ApiService)); };
ShuttleApiService.ɵprov = i0.ɵɵdefineInjectable({ token: ShuttleApiService, factory: ShuttleApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(ShuttleApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }, { type: i2.ApiService }]; }, null); })();
//# sourceMappingURL=shuttle-api.service.js.map